module.exports = __webpack_public_path__ + "img/oidc.a716819b.svg";